import user from '@/core/legacy-auth/users'

export default {
  get legacyViewDisabled() { return user.type.BUYER && !user.entity.ENTERPRISE },
  get receiptScanPrefill() { return process.env.FEATURE_RECEIPT_SCAN_PREFILL === 'true' }
}



// WEBPACK FOOTER //
// ./src/core/feature-flags/feature-flags.js